var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    {
      staticClass:
        "\n    profile-footer\n    justify-content-center\n    px-3\n    d-flex\n    align-items-center\n    flex-wrap\n  "
    },
    [
      _vm.$i18n.locale === "fa"
        ? _c("span", { staticClass: "ml-3 py-2" }, [
            _vm._v(
              "\n    ۱۴۰۳ - کلیه حقوق متعلق به شرکت نوآوران یکتا نت است.\n  "
            )
          ])
        : _c("span", { staticClass: "ml-3 py-2" }, [
            _vm._v(" All Right Reserved. ImageRivar 2020 ")
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "pb-2 pt-0 p-sm-2" }, [
        _c(
          "a",
          {
            staticClass: "link",
            attrs: {
              href:
                "https://accounts-cdn.yektanet.com/static/terms/privacy-policy.pdf",
              target: "_blank",
              "data-gtm-name": "main_privacy"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("privacy")) + "\n    ")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "mx-2 font-weight-bold" }, [_vm._v(".")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "link",
            attrs: {
              href:
                "https://accounts-cdn.yektanet.com/static/terms/terms-of-services.pdf",
              target: "_blank",
              "data-gtm-name": "main_terms_of_service"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("termsOfService")) + "\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }